"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Bucket_1 = __importDefault(require("../ua/Bucket"));
// https://reference.opcfoundation.org/v104/Core/docs/Part6/6.7.2/#6.7.2.3
class AsymmetricSecurityHeader {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.SecurityPolicyUri = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.SecurityPolicyUri, (_b !== null && _b !== void 0 ? _b : 'http://opcfoundation.org/UA/SecurityPolicy#None'));
        this.SenderCertificate = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.SenderCertificate, (_d !== null && _d !== void 0 ? _d : ''));
        this.ReceiverCertificateThumbprint = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.ReceiverCertificateThumbprint, (_f !== null && _f !== void 0 ? _f : ''));
    }
    encode() {
        const bucket = new Bucket_1.default();
        bucket.writeString(this.SecurityPolicyUri);
        bucket.writeString(this.SenderCertificate);
        bucket.writeString(this.ReceiverCertificateThumbprint);
        return bucket.bytes;
    }
    decode(b, position) {
        const bucket = new Bucket_1.default(b, position);
        this.SecurityPolicyUri = bucket.readString();
        this.SenderCertificate = bucket.readString();
        this.ReceiverCertificateThumbprint = bucket.readString();
        return bucket.position;
    }
}
exports.default = AsymmetricSecurityHeader;
